import { render, staticRenderFns } from "./DestinationDetails.vue?vue&type=template&id=3e80b9ce"
import script from "./DestinationDetails.vue?vue&type=script&lang=js"
export * from "./DestinationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports